import {
  CLEAR_REDUCERS,
  DELETE_ADDED_STICKER_SUCCESS,
  LOAD_JOURNAL_SUCCESS,
} from '../actions/actionTypes';
import _ from 'lodash';

const initialState = [];

const journalReducer = (state = [...initialState], action) => {
  let updatedState = [];
  switch (action.type) {
    case DELETE_ADDED_STICKER_SUCCESS:
      state.forEach((month) => {
        _.remove(month, function (currentObject) {
          return currentObject.id === action.payload;
        });
      });
      return [...state];
    case LOAD_JOURNAL_SUCCESS:
      state = action.payload;
      return [...state];
    case CLEAR_REDUCERS:
      updatedState = [...initialState];
      return updatedState;

    default:
      return state;
  }
};

export default journalReducer;
